import { createWithEqualityFn } from 'zustand/traditional';
import { devtools } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';

import type { PlayerActivityBatch } from '~/domains/market/services/playerActivityLiveUpdates.service';

const EMPTY_ACTIVITY: PlayerActivityBatch = {};

type PlayerActivityState = {
  byEventId: Map<string, PlayerActivityBatch>;
};

type PlayerActivityActions = {
  applyBatch: (eventId: string, batch: PlayerActivityBatch) => void;
  reset: () => void;
};

const initialState: PlayerActivityState = {
  byEventId: new Map(),
};

export const usePlayerActivityStore = createWithEqualityFn<
  PlayerActivityState & PlayerActivityActions
>()(
  devtools(
    (set) => ({
      ...initialState,

      applyBatch: (eventId, batch) =>
        set(
          (state) => ({
            byEventId: new Map(state.byEventId).set(eventId, {
              ...state.byEventId.get(eventId),
              ...batch,
            }),
          }),
          false,
          'applyBatch'
        ),

      reset: () => set(initialState, false, 'reset'),
    }),
    { name: 'PlayerActivityStore' }
  ),
  shallow
);

export function usePlayerActivity(eventId: string | undefined): PlayerActivityBatch {
  return usePlayerActivityStore(
    (state) => (eventId ? state.byEventId.get(eventId) : undefined) ?? EMPTY_ACTIVITY
  );
}
